<template>
  <tab-layout :full-width="true">
    <div slot="tabContent" class="bg-white rounded mb-4 p-3">
      <page-heading>{{ eventName }}</page-heading>

      <app-tab-switcher
        v-if="tabRounds.length"
        class="mb-3"
        :items="tabRounds"
        :value="String(activeRound)"
        @input="selectRound(Number($event))"
      />

      <p v-if="!loading && !draws.length" class="text-muted">
        The draw for this event is not yet published. Please try again later.
      </p>

      <div class="position-relative" style="min-height: 200px;">
        <div v-if="loading" class="table-overlay">
          <div class="table-spinner" />
        </div>
        <div v-if="draws.length" class="draws-table --public-table">
          <div class="draws-table__headers">
            <div class="draws-table__header-main">
              <div class="draws-table__row">
                <div class="draws-table__heading --runs"><strong>Runs</strong></div>
              </div>
            </div>
            <div class="draws-table__header-small">
              <div class="draws-table__row">
                <div class="draws-table__col --names">
                  <div class="draws-table__cell draws-table__heading-small">Competitor</div>
                  <div class="draws-table__cell draws-table__heading-small">Horse</div>
                </div>
              </div>
            </div>
          </div>
          <div class="draws-table__body">
            <div v-for="draw in draws" :key="draw.id" class="draws-table__row">
              <div class="draws-table__col --names">
                <div class="draws-table__cell"><span class="row-number">{{ draw.order }}. </span>{{ draw.rider }}<span v-if="draw.rider_deleted"> (deleted)</span></div>
                <div class="draws-table__cell">{{ draw.horse }}<span v-if="draw.horse_deleted"> (deleted)</span></div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-inline justify-content-between align-items-start mt-3">
          <div class="d-flex align-items-center justify-content-center justify-content-md-start form-group mb-3 mb-md-0 col-12 col-md-auto px-0">
            <span class="mr-2">Show</span>
            <app-multiselect
              class="draws-public-per-page"
              :value="perPage"
              :options="perPageOptions"
              :searchable="false"
              :disabled="loading"
              @input="changePerPage"
            />
            <span class="ml-2">Entries</span>
          </div>
          <div class="pagination-container form-group align-items-start justify-content-center mb-3 mb-md-0" v-show="totalPages > 1">
            <pagination
              :page="page"
              :total-pages="totalPages"
              :disabled="loading"
              :on-change="changePage"
            />
          </div>
        </div>
      </div>
    </div>
  </tab-layout>
</template>

<style scoped>
.draws-table.--public-table .draws-table__col.--names {
  justify-content: flex-start;
}

.draws-table.--public-table .draws-table__col.--names > .draws-table__cell {
  width: 31%;
  flex: 0 0 31%;
  text-align: left;
}

.draws-public-per-page {
  flex: 0 0 72px;
}

@media (max-width: 402px) {

  .draws-public-per-page {
    flex: 1 1 0;
    min-width: 0;
  }
}

@media (max-width: 575px) {

  .draws-table__col.--names {
    flex-wrap: wrap;
  }

  .draws-table__col.--names > .draws-table__cell {
    width: auto !important;
    flex: 1 1 0;
    min-width: 0;
    word-break: normal;
    overflow-wrap: break-word;
  }

  .draws-table__col.--names > .draws-table__cell:nth-of-type(2) {
    flex-basis: 100%;
    width: 100% !important;
  }
}
</style>

<script>
import { defineComponent, computed, getCurrentInstance } from '@vue/composition-api'
import TabLayout from '@/components/TabLayout'
import PageHeading from '@/components/PageHeading'
import AppTabSwitcher from '@/components/AppTabSwitcher'
import Pagination from '@/components/Pagination'
import AppMultiselect from '@/components/AppMultiselect'
import usePublicDraws from '@/composables/draws/usePublicDraws'

export default defineComponent({
  name: 'DrawsPublic',
  components: { TabLayout, PageHeading, AppTabSwitcher, Pagination, AppMultiselect },
  setup() {
    const { proxy } = getCurrentInstance()

    const eventId = computed(() => proxy.$route.params.eventId)
    const activeRound = computed(() => Number(proxy.$route.params.round) || 1)

    const {
      eventName, rounds, draws, loading, page, perPage, perPageOptions,
      totalPages, changePage, changePerPage
    } = usePublicDraws(proxy)

    function roundLabel(roundNum, roundType) {
      if (roundType === 3) return 'Final round'
      if (roundType === 4) return 'Run-off'
      return `Round ${roundNum}`
    }

    const tabRounds = computed(() => rounds.value.map(r => ({
      value: String(r.round),
      label: roundLabel(r.round, r.round_type)
    })))

    function selectRound(roundNum) {
      proxy.$router.push({ path: `/draws/public/${eventId.value}/${roundNum}`, query: { per_page: String(perPage.value) } })
    }

    return {
      eventName,
      tabRounds,
      activeRound,
      draws,
      page,
      totalPages,
      perPage,
      perPageOptions,
      changePage,
      changePerPage,
      loading,
      selectRound
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/views/Draws/Public/DrawsPublic.vue